import { Outlet } from 'react-router-dom'
import { motion } from 'framer-motion'

export function AuthLayout() {
  return (
    <div className="min-h-screen flex bg-[#0C1319]">
      {/* Left panel -- visual statement */}
      <div className="hidden lg:flex lg:w-[55%] relative overflow-hidden bg-[#080F14]">
        {/* Subtle radial glow */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary-400/5 via-transparent to-transparent" />

        {/* Logo top-left */}
        <div className="absolute top-8 left-10 flex items-center space-x-3">
          <img src="/logo192.png" alt="Synap" className="h-10 w-10" />
          <span className="text-xl font-semibold text-white">Synap</span>
        </div>

        {/* Center typographic statement */}
        <div className="flex items-center justify-center w-full px-16">
          <div>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.3 }}
              className="text-7xl font-bold text-white/[0.08] select-none leading-none mb-6"
            >
              16 agents.
            </motion.p>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.6 }}
              className="text-3xl font-semibold text-white leading-snug"
            >
              One operating system
              <br />
              for your entire
              <br />
              marketing department.
            </motion.p>
          </div>
        </div>

        {/* Bottom-left URL */}
        <div className="absolute bottom-8 left-10">
          <span className="text-sm text-white/30 tracking-wider">synapmarketing.com</span>
        </div>
      </div>

      {/* Right panel -- auth form */}
      <div className="flex-1 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
        {/* Mobile header */}
        <div className="flex items-center space-x-2 mb-10 lg:hidden">
          <img src="/logo192.png" alt="Synap" className="h-8 w-8" />
          <span className="text-lg font-semibold text-white">Synap</span>
        </div>

        <div className="w-full max-w-[380px] px-4 sm:px-0">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
